import { useEffect, useState } from "react";
import "./CrudContentPopup.scss";
import ModalContainer from "../ModalContainer";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useNotification from "../../../hooks/notification.hook";
import { cn } from "../../../lib/utils";
import usePlanContentPresetsCopy from "../../../hooks/plan-content-presets-copy.hook";
import { createTemplatesPlansContentPresetImportConfiguration } from "../../../services/plans-template-content-preset-import-configuration.service";

export default function CloneContentModal({ open, setOpen, model }) {
	const { t } = useTranslation();

	const { setUpdateListConf, planData } = usePlanContentPresetsCopy();

	// Set message
	yup.setLocale({
		// use constant translation keys for messages without values
		mixed: {
			required: ({ path }) => t("common:errors.required", { field: t(`common:fields.${path}`) }),
		},
	});

	// Schema Yup
	const schema = yup.object().shape({
		title: yup.string().required(),
	});

	const {
		register,
		setValue,
		handleSubmit,
		formState: { errors },
	} = useForm({ resolver: yupResolver(schema) });

	const { openNotification, helperErrorNotification } = useNotification();

	const [loading, setLoading] = useState(false);

	/**
	 * Form Handler
	 * @param {form modal} data
	 */
	async function confirmCopy(data) {
		if (loading) return;

		setLoading(true);

		const body = {
			title: data.title,
			templatePlan: planData?.template_plan_id,
			contentPreset: planData?.content_preset_id,
			selection_mode: "explicit",
			content_selections: model.content_selections,
			requirement_selections: model.requirement_selections,
		};

		try {
			await createTemplatesPlansContentPresetImportConfiguration(body);
			setUpdateListConf((i) => i + 1);
			setOpen(false);
		} catch (error) {
			helperErrorNotification(error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		if (open) {
			setValue("title", model ? `${model.title} (Copia)` : "");
		}
	}, [open]);

	/**
	 * Errors Form
	 */
	useEffect(() => {
		if (Object.keys(errors).length) {
			const fields = Object.values(errors).map((er) => er.message);
			openNotification({ fields, status: "error" });
		}
	}, [errors]);

	return (
		<ModalContainer isOpen={open} setIsOpen={setOpen} disableClose={loading}>
			<div className="main_modal_content">
				<button
					className="main_close"
					onClick={() => !loading && setOpen(false)}
					type="button"
					aria-label="Chiudi"
				>
					<span className="icon_10 default close icon_mask !bg-white"></span>
				</button>

				<div className="main_header_modal">
					<span className="title">Duplica configurazione di copia</span>

					<div className="pt-5 uppercase text-12 font-bold text-dark-50">
						Configurazione selezionata
					</div>

					<div className="text-14 mt-1">{model?.name}</div>
				</div>

				<div className={"main_body_modal"}>
					<form
						id="content-conf-form"
						onSubmit={handleSubmit(confirmCopy)}
						className="global_form_landing"
					>
						<div className="base">
							<div className="wrap_input_landing">
								<label className="label_input" htmlFor="title-new-conf">
									Nome nuova configurazione
								</label>
								<input
									type="text"
									{...register("title")}
									className={cn("landing", errors.title && "err")}
									id="title-new-conf"
								/>
							</div>
						</div>
					</form>
				</div>

				<div className="main_footer_modal">
					<div className="right_content">
						{/* Main Cta */}
						<button
							type="submit"
							form="content-conf-form"
							className={cn("button fill success", loading && "loading")}
						>
							<div className="load_content">Conferma</div>
							<div className="main_loader_icon fade_in"></div>
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
}
